<template>
  <bk-view class="rightItemCard-container" 
		:class="{
			[`rightItemCard-rightType-${rightType}`]: rightType
		}"
	>
		<bk-view class="view-name-main">
			<bk-view class="view-name">{{rightItem.name}}</bk-view>
			<bk-icon icon="icon-youjiantou"  v-if="rightType !=='giftCard'" />
		</bk-view>

		<bk-view class="view-period-main">
			<bk-validDateText langCode_label="userInfo_memberRights_rightItemCard_period" :validInfo="rightItem" />
			<bk-icon v-if="rightType==='giftCard'" icon="icon-youjiantou" />
		</bk-view>

		<bk-view class="view-discount-main">
			<bk-view class="view-discount-item" :style="item.style" v-for="(item,index) in discountList" :key="index">
				<bk-lang class="view-label" :code="item.langCode"></bk-lang>
				<bk-view class="view-value">
					<bk-price v-if="item.type==='price'" :unitText="currencySymbol" :value="item.value"></bk-price>
					<bk-view v-else>{{ item.value !=null ? item.value : '-'}}</bk-view>
				</bk-view>
			</bk-view>
		</bk-view>
	</bk-view>
</template>

<script>
	export default {
		name:'rightItemCard',
		props:{
			rightType:String,
			rightItem:Object,
			currencySymbol:String,
		},
		data (){
			return {
				excluxivePriceText: this.$bk_getTextWithLangCode('userInfo_memberRights_rightItemCard_excluxivePrice')
			};
		},
		computed:{
			discountList (){
				const res = this.rightItem;
				let items = [];
				
				let exclusive = this.isExclusivePrice();

				// 会员权益
				if(this.rightType==='membership'){

					// 储值
					if(res.goodsType===1){
						items = [
							{langCode:'userInfo_memberRights_rightItemCard_balance', value: res.balance, type:'price', style:{ width:'30%'}},
							{langCode:'userInfo_memberRights_rightItemCard_bonusbalance', value: res.bonusBalance, type:'price', style:{ width:'30%'}},
							{
								langCode:'userInfo_memberRights_rightItemCard_discount', 
								value: exclusive ? this.excluxivePriceText : `${res.projectDiscountText || '10%'}/${res.productDiscountText}/${res.privilegeDiscountText}`,
								style:{ width:'40%'}
							},
						];
					}
					// 折扣
					if(res.goodsType===2){
						let sessions = res.usageLimit ? res.useTimes : this.$bk_lang['userInfo_memberRights_usageLimit'];
						items = [
							{langCode:'userInfo_memberRights_rightItemCard_sessions', value: sessions, style:{ width:'30%'} },
							{
								langCode:'userInfo_memberRights_rightItemCard_discount', 
								value: exclusive ? this.excluxivePriceText : `${res.projectDiscountText}/${res.productDiscountText}/${res.privilegeDiscountText}`,
								style:{ width:'70%'}
							},
						];
					}
					// 品项
					if(res.goodsType===3){
						items = [
							{langCode:'userInfo_memberRights_rightItemCard_sessions', value:(res.buyTimes || 0) + (res.giveTimes || 0)},
							{langCode:'userInfo_memberRights_rightItemCard_remaining', value: res.remainTimes},
						];
					}
				
				}

				// 礼品卡
				if(this.rightType==='giftCard'){
					if(res.goodsType===4){
						items = [
							{langCode:'userInfo_memberRights_rightItemCard_value', value: res.value, type:'price'},
						];
					}
					
					if(res.goodsType===5){
						items = [
							{langCode:'userInfo_memberRights_rightItemCard_sessions', value: res.singleUsageQty},
						];
					}
				}

				// 套餐 
				if(this.rightType==='packages'){
					items = [
						{langCode:'userInfo_memberRights_rightItemCard_remainingProduct', value: res.remainProductUseNum || 0},
						{langCode:'userInfo_memberRights_rightItemCard_remainingService', value: res.remainProjectUseNum || 0},
					];
				}
				return items;
			}
		},
		methods:{
			isExclusivePrice (){
				const { projectExclusivePriceList=[], productExclusivePriceList=[], rightExclusivePriceList=[]} = this.rightItem;
				return projectExclusivePriceList?.length || productExclusivePriceList?.length || rightExclusivePriceList?.length;
			}
		}
	};
</script>

<style lang="less">
@import './rightItemCard.less';
</style>